import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Card } from '@deckplan.io/common/cards';

@Component({
    selector: 'app-card-image',
    templateUrl: './card-image.component.html',
    styleUrls: ['./card-image.component.scss']
})
export class CardImageComponent {

    @Input() public card: Card;
    // eslint-disable-next-line no-magic-numbers
    @Input() public width = 150;
    @Input() public clickable = true;
    @Input() public hoverable = true;
    @Input() public draggable = true;
    @Input() public addable = true;
    @Input() public removable = true;
    @Input() public quantity = 1;
    @Output() public cardClicked = new EventEmitter<any>();
    @Output() public cardContextClicked = new EventEmitter<{ event: MouseEvent; data: any }>();
    @Output() public transform = new EventEmitter<boolean>();

    public transformed = false;

    @Input() public isValid = (card: Card) => true;

    public onCardContext(mouseEvent: MouseEvent, card: Card) {
        // Stop default context menu from showing
        mouseEvent.stopPropagation();
        this.cardContextClicked.emit({event: mouseEvent, data: card});
        return false;
    }

    public getImage(): string {
        if (!this.card) {
            return 'https://via.placeholder.com/250x349?text=Loading...';
        } else if (this.card.images.large) {
            return this.card.images.large;
        } else if (this.card.cardFaces.length > 0 && !this.transformed && this.card.cardFaces[0].image_uris) {
            // Scryfall occasionally publishes card object definitions that don't have an image_uris field.
            return this.card.cardFaces[0].image_uris.large;
        } else if (this.card.cardFaces.length > 1 && this.transformed && this.card.cardFaces[1].image_uris) {
            return this.card.cardFaces[1].image_uris.large;
        } else {
            return 'https://via.placeholder.com/250x349?text=No Image Available';
        }
    }

    public flippable(): boolean {
        return this.card && this.card.cardFaces && this.card.cardFaces.length > 1 &&
               this.card.layout !== 'flip' && this.card.layout !== 'adventure' && this.card.layout !== 'split';
    }

    public doTransform(mouseEvent: MouseEvent) {
        this.transformed = !this.transformed;
        this.transform.emit(this.transformed);
        mouseEvent.stopImmediatePropagation();
        return false;
    }
}
